import { computed, inject, Injectable } from '@angular/core';
import { UserService } from '@core';
import { ENV } from '@di-tokens';

@Injectable({ providedIn: 'root' })
export class ChaseAuthLinkService {
  userService = inject(UserService);
  ENV = inject(ENV);

  public link = computed(() => this.ENV.chaseShoppingWebsiteUrl + `&accountId=${this.userService.user()?.accountId}`);
}
